module.exports = __webpack_public_path__ + "static/img/pic_2_2@2x.f443dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/shortVideo/pic_2_2@2x.png
// module id = Zj63
// module chunks = 0